import Modal from 'component/hoc/modal/Modal';
import React, { useState } from 'react';
import styles from './ViewDetailsModal.module.scss';
import { formatDateTime } from 'component/molecules/Table/TableComponents/factory/factory';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const ViewDetailsModal = ({ isOpen, onClose, selectedItem }) => {
  const [showResponseHeader, setShowResponseHeader] = useState(false);
  const [showResponseBody, setShowResponseBody] = useState(false);

  const toggleResponseHeader = () => setShowResponseHeader((prev) => !prev);
  const toggleResponseBody = () => setShowResponseBody((prev) => !prev);

  const renderStatus = (value) => {
    if (value === 'Failed') {
      return (
        <div className={styles.statusFailed}>
          <SvgWithBranding type='failed' />
          <span>{value}</span>
        </div>
      );
    } else if (value === 'Success' || value === 'OK') {
      return (
        <div className={styles.statusSuccess}>
          <SvgWithBranding type='success' />
          <span>Success</span>
        </div>
      );
    } else {
      return (
        <div className={styles.statusInProgress}>
          <SvgWithBranding type='inProgress' />
          <span>{value}</span>
        </div>
      );
    }
  };

  let parsedResponseBody = null;
  try {
    parsedResponseBody = JSON.parse(selectedItem?.responseBody);
  } catch {}

  const renderResponseBodyTable = () => {
    if (!parsedResponseBody) return null;
    if (Array.isArray(parsedResponseBody) && parsedResponseBody.length > 0) {
      const columns = Object.keys(parsedResponseBody[0]);
      return (
        <table className={styles.responseTable}>
          <thead className={styles.tableHeader}>
            <tr>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {parsedResponseBody.map((row, index) => (
              <tr key={index}>
                {columns.map((col) => (
                  <td key={col} className={styles['body-value']}>
                    {typeof row[col] === 'object' && row[col] !== null
                      ? JSON.stringify(row[col])
                      : row[col]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
    if (typeof parsedResponseBody === 'object' && parsedResponseBody !== null) {
      return (
        <table className={styles.responseTable}>
          <tbody>
            {Object.entries(parsedResponseBody).map(([key, value]) => (
              <tr key={key}>
                <td>{key}</td>
                <td>
                  {typeof value === 'object' && value !== null
                    ? JSON.stringify(value)
                    : value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    return null;
  };

  return (
    <Modal
      title='API Log Details'
      isOpen={isOpen}
      onClose={onClose}
      classname={styles['modal']}
    >
      <div className={styles.cont}>
        <div className={styles.infoCont}>
          <div className={styles.messages}>
            <div className={styles.message_cont}>
              <div className={styles.info}>
                <p>Status</p>
                {renderStatus(selectedItem?.status)}
              </div>
              <div className={styles.info}>
                <p>Timestamp</p>
                <span>{formatDateTime(selectedItem?.dateStarted) || '-'}</span>
              </div>
              <div className={styles.info}>
                <p>Duration</p>
                <span>{Math.round(selectedItem?.durration * 1000)}ms</span>
              </div>
              <div className={styles.info}>
                <p>Method</p>
                <span>
                  {selectedItem?.type === 1
                    ? 'GET'
                    : selectedItem?.type === 2
                    ? 'POST'
                    : selectedItem?.type === 3
                    ? 'DELETE'
                    : 'PUT'}
                </span>
              </div>
              <div className={styles.info}>
                <p>Endpoint</p>
                <span className={styles['endpoint-text']}>
                  {selectedItem?.endpoint ?? '-'}
                </span>
              </div>
            </div>
            <div className={styles.message_cont}>
              <h5>Message</h5>
              <p>{selectedItem?.message ?? '-'}</p>
              <h5>Response Code</h5>
              <div className={styles['error-cont']}>-</div>
            </div>
          </div>
        </div>

        <div className={styles.infoCont}>
          <div className={styles.request}>
            <p>Request Header</p>
            <div className={styles.request_text}>
              <span>{selectedItem?.requestHeader}</span>
            </div>
          </div>

          <div className={styles.request}>
            <div
              className={styles.itemExpandableHeader}
              onClick={toggleResponseHeader}
            >
              <p>Response Header</p>
              <SvgWithBranding
                type='chevronDown'
                className={`${styles.arrow} ${
                  showResponseHeader ? styles.open : ''
                }`}
              />
            </div>
            <div
              className={`${styles.responseHeaderText} ${
                showResponseHeader ? styles.visible : ''
              }`}
            >
              <span>{selectedItem?.responseHeader}</span>
            </div>
          </div>

          <div className={styles.request}>
            <div
              className={styles.itemExpandableHeader}
              onClick={toggleResponseBody}
            >
              <p>Response Body</p>
              <SvgWithBranding
                type='chevronDown'
                className={`${styles.arrow} ${
                  showResponseBody ? styles.open : ''
                }`}
              />
            </div>
            <div
              className={`${styles.responseBodyText} ${
                showResponseBody ? styles.visible : ''
              }`}
            >
              {renderResponseBodyTable() ? (
                <div className={styles.tableScroll}>
                  {renderResponseBodyTable()}
                </div>
              ) : (
                <span>{selectedItem?.responseBody}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewDetailsModal;
